module.exports = __webpack_public_path__ + "static/media/summit-gif-loading-submit-face.7d0a30cd.gif";